import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import MembershipOverview from "../../elements/membership-overview";
import RadioButtonGroup from "../../elements/radio-button-group";
import PrimaryButton from "../../elements/primary-button";
import AccordionWrapper from "../accordion-wrapper";
import PrimaryLink from "../../elements/primary-link";
import { connect } from "react-redux";
import { selectUserState } from "../../selectors/application";
import { getUserInfo } from "../../services/userService";
import { setUserInfoAction } from "../../redux/actions";
import { canUseDOM } from "../../utils";
import { S_LANG, webStorage } from "../../utils/webStorage";
import { getDictionary } from "../../services/siteService";
import { dictTypes } from "../../utils/lynkco-constants";
import "./style.scss";
function MembershipDetailsSection({ user, setUserInfo, membershipTitleType, membershipTitleBody, membershipBody, button, membershipOverview, disclaimer, accordionItems, membershipLink, match, onChangeMembershipSubmit = () => {} }) {
  const isSSR = !canUseDOM();
  const lang = isSSR ? null : webStorage.get(S_LANG);
  const langInfo = lang ? lang.split("-") : [];
  const language = langInfo.length > 0 ? langInfo[0].toUpperCase() : null;
  // todo get from e-commerce
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedPrice, setSelectedPrice] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState({ value: true });
  const [overviewBody, setOverviewBody] = useState(null);
  const [radioDisabled, setRadioDisabled] = useState(true);
  useEffect(() => {
    init().then();
  }, [membershipOverview, user?.membershipCode]);
  const items = {
    selectedOption,
    options
  };
  const init = async () => {
    const user = await getUserInfo();
    const dict = await getDictionary(dictTypes.membership); //getMembershipLabels();
    setUserInfo(user);
    const tempOptions = [];
    for (let level = 0, len = dict.length; level < len; level++) {
      const { code, price, isHide } = membershipOverview.fields[`membership${level}`].fields;
      const label = dict[level].languages[language]?.dicName;
      const option = {
        label,
        value: dict[level].dicCode,
        level
      };
      if (code.value === user?.membershipCode) {
        const currentLevelDescription = membershipOverview.fields.currentLevelDescription?.value;
        if (currentLevelDescription) {
          option.label += ` (${currentLevelDescription})`;
        }
        setSelectedOption(option);
        setOverviewBody(label);
        setSelectedPrice(price.value);
      }
      if (!isHide || !isHide.value) {
        tempOptions.push(option);
      }
    }
    setOptions(tempOptions);
    if (user && user.membershipCode === "MEMBERSHIP04") {
      setRadioDisabled(true);
    } else {
      setRadioDisabled(false);
    }
  };
  const onLevelChange = level => {
    setSelectedOption(level);
    setButtonDisabled({ value: level.value === user?.membershipCode });
  };

  return (
    <div className="form-membership-section">
      <div className="form-membership-section-heading">
        <Heading type={membershipTitleType} html={membershipTitleBody} typographyClass={"type-h3"} />
      </div>
      <div className="form-membership-section-body">
        <BodyText html={membershipBody.value} />
      </div>
      <div className="form-membership-details">
        <MembershipOverview
          {...{
            overview: {
              headingType: membershipOverview.fields.titleType,
              heading: membershipOverview.fields.title,
              body: overviewBody,
              membershipFee: selectedPrice,
              // TODO update with values from integration
              currency: ""
            },
            match: match
          }}
        />
      </div>
      {/* sprint 4 integration */}
      <div className="form-membership-section-fields">
        <RadioButtonGroup
          {...{
            ...items,
            isDisabled: radioDisabled,
            onChange: value => onLevelChange(value)
          }}
        />
      </div>
      {!radioDisabled && button != null && (
        <div className="form-membership-section-button">
          <PrimaryButton
            {...{
              ...button,
              callback: evt => onChangeMembershipSubmit(evt, selectedOption),
              isDisabled: buttonDisabled
            }}
          />
        </div>
      )}
      {radioDisabled && disclaimer != null && <BodyText html={disclaimer.value} className={"disclaimer"} />}
      <div className="border-row"></div>
      {accordionItems.map((element, index) => (
        <AccordionWrapper
          heading={{
            type: element.fields.titleType,
            html: element.fields.titleBody
          }}
          key={`accordion-wrapper-${index}`}
        >
          <div className="accordian-body">
            <BodyText html={element.fields.body.value} />
          </div>
        </AccordionWrapper>
      ))}
      <div className="form-membership-section-button">{membershipLink && <PrimaryLink {...membershipLink.fields} />}</div>
    </div>
  );
}
const mapStateToProps = state => ({
  user: selectUserState(state)
});
const mapDispatchToProps = dispatch => ({
  setUserInfo: data => dispatch(setUserInfoAction(data))
});
export default connect(mapStateToProps, mapDispatchToProps)(MembershipDetailsSection);
MembershipDetailsSection.propTypes = {
  membershipTitleType: PropTypes.object,
  membershipTitleBody: PropTypes.object,
  membershipBody: PropTypes.shape({ value: PropTypes.string }),
  button: PropTypes.object,
  membershipOverview: PropTypes.object,
  disclaimer: PropTypes.shape({ value: PropTypes.string }),
  accordionItems: PropTypes.arrayOf(
    PropTypes.shape({
      fields: PropTypes.shape({
        titleType: PropTypes.object,
        titleBody: PropTypes.object,
        body: PropTypes.shape({ value: PropTypes.string })
      })
    })
  ),
  membershipLink: PropTypes.object,
  onChangeMembershipSubmit: PropTypes.func
};
